import Layout from "../views/layout/Layout";

export default {
    path: '/productStorage',
    component: Layout,
    redirect: '/productStorage/equipmentModel',
    meta: {title: '仓储模块', icon: 'el-icon-house'},
    children: [{
        path: 'equipmentModel',
        name: 'equipmentModel',
        component: () => import('@/views/productStorage/equipmentModel/index'),
        meta: {title: '设备型号设置', icon: 'product-cate'},
        auth: 'productStorage:equipmentModel'
    }, {
        path: 'deviceInventory',
        name: 'deviceInventory',
        component: () => import('@/views/productStorage/deviceInventory/index'),
        meta: {title: '设备库存管理', icon: 'product-cate'},
        auth: 'productStorage:deviceInventory'
    }, {
        path: 'transferCheck',
        name: 'transferCheck',
        component: () => import('@/views/productStorage/transferCheck/index'),
        meta: {title: '划拨出库审核', icon: 'product-cate'},
        auth: 'productStorage:transferCheck'
    }, {
        path: 'purchaseCheck',
        name: 'purchaseCheck',
        component: () => import('@/views/productStorage/purchaseCheck/index'),
        meta: {title: '采购申请审核', icon: 'product-cate'},
        auth: 'productStorage:purchaseCheck'
    }, {
        path: 'deviceForm',
        name: 'deviceForm',
        component: () => import('@/views/productStorage/deviceForm/index'),
        meta: {title: '设备表', icon: 'product-cate'},
        auth: 'productStorage:deviceForm'
    }, {
        path: 'inventoryRecord',
        name: 'inventoryRecord',
        component: () => import('@/views/productStorage/inventoryRecord/index'),
        meta: {title: '库存记录', icon: 'product-cate'},
        auth: 'productStorage:inventoryRecord'
    }, {
        path: 'deviceReportForm',
        name: 'deviceReportForm',
        component: () => import('@/views/productStorage/deviceReportForm/index'),
        meta: {title: '设备报表', icon: 'product-cate'},
        auth: 'productStorage:deviceReportForm'
    }, {
        path: 'productStorageConfig',
        name: 'productStorageConfig',
        component: () => import('@/views/productStorage/productStorageConfig/index'),
        meta: {title: '仓储配置', icon: 'product-cate'},
        auth: 'productStorage:productStorageConfig'
    }, {
        path: 'series',
        name: 'series',
        component: () => import('@/views/productStorage/series/index'),
        meta: {title: '系列管理', icon: 'product-cate'},
        auth: 'productStorage:series'
    }, {
        path: 'virtualCode',
        name: 'virtualCode',
        hidden: true,
        component: () => import('@/views/productStorage/virtualCode/index'),
        meta: {title: '虚拟码管理', icon: 'product-cate'},
        auth: 'productStorage:virtualCode'
    }, {
        path: 'addRecord',
        name: 'addRecord',
        component: () => import('@/views/productStorage/virtualCode/addRecord/index'),
        meta: {title: '查看新增记录', icon: 'product-cate'},
        auth: 'productStorage:addRecord',
        hidden: true,
    }, {
        path: 'deviceFaultRepair',
        name: 'deviceFaultRepair',
        component: () => import('@/views/productStorage/deviceFaultRepair/index'),
        meta: {title: '设备故障维修', icon: 'product-cate'},
        auth: 'productStorage:deviceFaultRepair'
    }]
}



// WEBPACK FOOTER //
// ./src/router/productStorage.js